module.exports = __webpack_public_path__ + "static/media/bootstrap-4.cb0c27b1.svg";